var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisionIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00EBAA",
    strokeWidth: "2px",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 15h4v1.5A2.5 2.5 0 007.5 19h0a2.5 2.5 0 002.5-2.5V15h10v-1.5a2.5 2.5 0 012.5-2.5h0a2.5 2.5 0 012.5 2.5V15h4",
    stroke: "#00EBAA",
    fill: "none",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 29v-4h1.5a2.5 2.5 0 002.5-2.5h0a2.5 2.5 0 00-2.5-2.5H15V10h-1.5A2.5 2.5 0 0111 7.5h0A2.5 2.5 0 0113.5 5H15V1",
    stroke: "#00EBAA",
    fill: "none",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1h28v28H1z",
    stroke: "#00EBAA",
    fill: "none",
    strokeWidth: "2px"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionIcon1);
export default __webpack_public_path__ + "static/media/vision-icon-1.1f6be089d738ea6997d1227408b7c997.svg";
export { ForwardRef as ReactComponent };